import { Grid } from '@mui/material'

import { SuccessIcon } from 'src/assets/icons'

import useStyles from './styles'
import { HelperWrapper } from '../helper-wrapper'
import { ETranslationNs } from 'src/types'

export interface IProgressStep {
  steps: string[]
  activeIndex: number
}

interface IProps {
  hasPassed: boolean
  isActive: boolean
  step: string
}

const StepItem = ({ hasPassed, isActive, step }: IProps) => {
  const classes = useStyles({ hasPassed, isActive })

  return (
    <Grid className={classes.stepWrapper}>
      {hasPassed ? (
        <SuccessIcon className={classes.stepIcon} />
      ) : (
        <Grid className={classes.stepCircle} />
      )}
      <HelperWrapper t={step} ns={ETranslationNs.UserProfile} />
    </Grid>
  )
}

interface IProgressStepsProps {
  progressStep: IProgressStep
}

const ProgressSteps = ({ progressStep }: IProgressStepsProps) => {
  const classes = useStyles({})

  return (
    <Grid className={classes.stepsWrapper}>
      {progressStep.steps.map((step, index) => (
        <StepItem
          key={step}
          hasPassed={index < progressStep.activeIndex}
          isActive={index === progressStep.activeIndex}
          step={step}
        />
      ))}
    </Grid>
  )
}

export { ProgressSteps }
